class Signer {
}
export {
  Signer
};
//# sourceMappingURL=signer.js.map
